import { IonDatetime, ModalController } from '@ionic/angular';
import { Component, Input, ViewChild } from '@angular/core';
import { DatePickerHourCycleTypeEnum, DatePickerPresentationTypeEnum, DatePickerRoleTypeEnum } from '../../models';

@Component({
	selector: 'app-date-picker-modal',
	templateUrl: './date-picker-modal.component.html',
	styleUrls: ['./date-picker-modal.component.scss']
})
export class DatePickerModalComponent {
	@Input() public date: string;
	@Input() public presentationType: DatePickerPresentationTypeEnum;
	@Input() public hourCycleType: DatePickerHourCycleTypeEnum;
	@ViewChild(IonDatetime) public datetime: IonDatetime;

	public constructor(private modalController: ModalController) {}

	public handleDate(e: any): void {
		this.date = e.detail.value;

		this.modalController.dismiss(
			{
				dismissed: true,
				date: this.date
			},
			DatePickerRoleTypeEnum.Save
		);
	}

	public cancelModal(): void {
		this.modalController.dismiss(
			{
				dismissed: true,
				date: this.date
			},
			DatePickerRoleTypeEnum.Cancel
		);
	}

	public confirm() {
		this.datetime.confirm(true);
	}
}
